module.exports = __webpack_public_path__ + "img/invite.5e2ff861.svg";